import useUser from '@hooks/auth/useUser';
import { Fragment, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

function AuthGuardDisplay({ children }:Props) {
    const { user } = useUser();
    if (user) {
        return children;
    }
    return (
        <Fragment/>
    );
}

export default AuthGuardDisplay;
